export function addressHtml(addr) {
  let result = '';

  result += '<table>';
  result += '<tbody>';
  result += `<tr><td colSpan="3">${addr.first_name} ${addr.last_name}</td></tr>`
  if (addr.address1) {
    result += `<tr><td colSpan="3">${addr.address1}</td></tr>`;
  }
  if (addr.address2) {
    result += `<tr><td colSpan="3">${addr.address2}</td></tr>`;
  }

  result += `<tr><td>${addr.city}</td><td>${addr.province}</td><td>${addr.zip}</td></tr>`;

  result += '</tbody>';
  result += '</table>';
  return result;
}
